import React from 'react';
import { GlassCard } from '../../ui/Card';
import { PrimaryButton } from '../../ui/Button';
import { EmailIcon } from '../../ui/Icons';
import { trackClick, trackExternalLink } from '../../utils/yandexMetrika';

const PortfolioContactSection: React.FC = () => {
    return (
        <div className="portfolio-contact">
            <GlassCard>
                <div className="portfolio-contact-content">
                    <h2 className="section-title text-center">
                        Хотите обсудить <strong>ваш проект?</strong>
                    </h2>
                    <p className="hero-description text-center">
                        Свяжитесь со мной, чтобы обсудить детали и получить консультацию
                    </p>
                    <div className="cta-actions-wrapper" style={{ justifyContent: 'center', gap: '20px' }}>
                        <PrimaryButton 
                            href="https://t.me/vip777swag"
                            target="_blank"
                            rel="noreferrer"
                            onClick={() => {
                                trackClick('portfolio_contact_telegram');
                                trackExternalLink('https://t.me/vip777swag');
                            }}
                        >
                            Связаться со мной
                        </PrimaryButton>
                        <a
                            href="mailto:darikarpenko@yandex.ru"
                            className="icon-link-circle small click-anim"
                            title="Email"
                            onClick={() => {
                                trackClick('portfolio_contact_email');
                            }}
                        >
                            <EmailIcon />
                        </a>
                    </div>
                </div>
            </GlassCard>
        </div>
    );
};

export default PortfolioContactSection;
